import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useQuery } from "@tanstack/react-query";
import { NotificationConfigurationsAvailableNotificationData } from "../types/configurations.type";

export const useNotificationsConfigurationsAvailableNotifications = () => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: NotificationConfigurationsAvailableNotificationData[] } }, Error, NotificationConfigurationsAvailableNotificationData[]>({
    queryKey: ['notificationConfigurationsAvailableNotifications'],
    queryFn: () => privateAxios.get(`/notification_configurations/available_notifications`),
    select: (data) => data?.data?.data,
  });
}
